'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

require('@utils/flexible');

require('babel-polyfill');

var _es6Promise = require('es6-promise');

var _es6Promise2 = _interopRequireDefault(_es6Promise);

require('./mixins');

require('./plugins');

require('@assets/stylus/index.styl');

var _app = require('./app.vue');

var _app2 = _interopRequireDefault(_app);

var _router = require('./router');

var _router2 = _interopRequireDefault(_router);

var _vant = require('vant');

require('./components');

var _sysinfo = require('@utils/sysinfo');

var _sysinfo2 = _interopRequireDefault(_sysinfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('es6-promise').polyfill();
// import FastClick from 'fastclick';

_es6Promise2.default.polyfill();

_vue2.default.use(_vant.Search);

// FastClick.attach(document.body);

(0, _sysinfo2.default)().then(function () {
  new _vue2.default({
    el: '#app',
    router: _router2.default,
    render: function render(h) {
      return h(_app2.default);
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 242
// module chunks = 14